module.exports = __webpack_public_path__ + "static/media/empty-state-company.2d93285d.png";